<template>
    <path style="fill:#281F1F;" d="M70.3,36.7c-1.2-1.1-3.2-1.5-4.7-1.7c-1.9-0.3-3.7-0.6-5.6-0.5c-1.6,0.1-3,0.1-3.9,1.5c0,0,0,0,0,0.1
	c-0.6-0.4-1.6-0.4-2-0.4c-0.4,0-1.4,0-2,0.4c0,0,0,0,0-0.1c-0.9-1.4-2.4-1.5-3.9-1.5c-2-0.1-3.7,0.1-5.6,0.5
	c-1.6,0.3-3.5,0.6-4.7,1.7c-1,1-1.3,2.8-1,4.2c0.8,4.7,6.9,8.9,11.3,6c2.3-1.5,3.9-3.5,4.4-6.2c0-0.1,0-0.1,0-0.2
	c0.2-1.2,0.4-2.5-0.1-3.7l0.1,0c0.3-0.2,0.9-0.3,1.7-0.3c0.7,0,1.4,0.1,1.7,0.3l0.1,0c-0.4,1.2-0.3,2.5-0.1,3.7c0,0.1,0,0.1,0,0.2
	c0.5,2.7,2.1,4.7,4.4,6.2c4.4,2.9,10.6-1.3,11.3-6C71.6,39.5,71.4,37.7,70.3,36.7z"/>
</template>

<script>
    export default {
        name: 'Eye3',
    }
</script>
